var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(-1056 -264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 14,
    height: 14,
    transform: "translate(1056 264)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "corner-up-right",
    transform: "translate(1053.372 261.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M15,11.035l3.517-3.517L15,4",
    transform: "translate(-3.262)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M4,16.738V11.814A2.814,2.814,0,0,1,6.814,9h8.442",
    transform: "translate(0 -1.483)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardMessageIcon);
export default __webpack_public_path__ + "static/media/forward-message-icon.3fd4a793141fa2c56a3f6a797677bc82.svg";
export { ForwardRef as ReactComponent };